import type { GetFeesMasterParams } from './feesMasterContracts'

export const feesMasterKeys = {
  all: ['feesMaster'] as const,

  lists: () => [...feesMasterKeys.all, 'list'] as const,
  list: (params: GetFeesMasterParams) => [...feesMasterKeys.lists(), params] as const,

  details: () => [...feesMasterKeys.all, 'detail'] as const,
  detail: (id: string) => [...feesMasterKeys.details(), id] as const,

  // Nested under the detail so superseding a fee invalidates its history too.
  versions: (id: string) => [...feesMasterKeys.detail(id), 'versions'] as const,
}
